import { Injectable } from '@angular/core';
import { VertraegeService } from './vertraege.service';
import { NotificationApiService } from '../../generated/api/notification/notification.service';
import {
    Notification,
    NotificationsResponse,
    NotificationType,
    VertragData
} from '../../generated/api/kreditportalBackendAPI.schemas';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationsService {

    constructor(
        private readonly notificationApiService: NotificationApiService,
        private readonly vertraegeService: VertraegeService
    ) {
    }

    getNachrichten(): Observable<NotificationsResponse> {
        return this.notificationApiService.getNotifications();

        // FIXME wat is dat hier?
        // return this.vertraegeService.getVertraegeNummernListe()
        //
        // return this.vertraegeProvider.getVertraegeP().then(vertrageResponse => {
        //     if (!vertrageResponse) {
        //         return Promise.resolve(new Messages());
        //     }
        //
        //     this.filterVertraege(vertrageResponse.vertraege);
        //     const messageWrapper: Messages = new Messages();
        //
        //     return this.getWithLoaderAnimPromise(
        //         new RequestWrapper(new EmptyModel()),
        //         new Messages()
        //     ).then(msgs => {
        //         messageWrapper.messages = msgs.messages.concat(this.filterVertraege(vertrageResponse.vertraege));
        //         return messageWrapper;
        //     });
        // });
    }

    private filterVertraege(vertraege: VertragData[]): Notification[] {
        const result: Notification[] = [];

        for (const vertrag of vertraege) {
            NotificationsService.checkRahmenauslastungWarning(vertrag, result);
        }

        return result;
    }

    private static checkRahmenauslastungWarning(vertrag: VertragData, arr: Notification[]) {
        if (   vertrag.rahmenBetrag && vertrag.rahmenBetrag !== 0
            && Math.floor(100 * vertrag.rahmenBelastung / vertrag.rahmenBetrag) >= 80
        ) {
            const rahmenauslastungNotification: Notification = {
                message: 'Ihre Kreditlinie ist bereits zu 80% oder mehr ausgelastet. Gerne prüfen wir eine Erhöhung – bitte klicken Sie <strong>hier</strong>.',
                type: NotificationType.warning,
                targetURI: '/kreditportal/vertraege/' + vertrag.vertragHandle.vsnrNumerisch
            }

            arr.push(rahmenauslastungNotification);
        }
    }

}
